import store from '@/state/store'

export default [{
        path: '/',
        name: 'default',
        meta: { authRequired: false },
        component: () =>
            import ('./views/dashboards/default'),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () =>
            import ('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {

                store.dispatch('auth/logout')

                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                        (route) => route.push('/login')
                    )
                    // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'default' } : {...routeFrom })
            },
        },
    },

    {
        path: '/update_password',
        name: 'Update Password',
        component: () =>
            import ('./views/account/update_password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },

    {
        path: '/businesslist',
        name: 'Business List',
        component: () =>
            import ('./views/account/businesslist'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/products/add_product',
        name: 'Add Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/add_product')
    },
    {
        path: '/units/view',
        name: 'Product Units',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/units')
    },
    {
        path: '/products/search_products',
        name: 'Search Product',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/search_products')
    },
    {
        path: '/categories/view',
        name: 'Product Categories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/categories')
    },
    {
        path: '/business/products',
        name: 'Business Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/business')
    },
    {
        path: '/products/view',
        name: 'Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/products')
    },
    {
        path: '/products/units',
        name: 'ProductUnits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/product_units')
    },
    {
        path: '/services/view',
        name: 'Services',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/services')
    },
    {
        path: '/suppliers/view',
        name: 'Suppliers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/suppliers')
    },
    {
        path: '/supplier/deposits',
        name: 'Supplier Deposits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/supplier_deposit')
    },
    {
        path: '/stock/view',
        name: 'Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stock')
    },
    {
        path: '/stock/allstock',
        name: 'All Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/allstock')
    },
    {
        path: '/stock/stockvalue',
        name: 'Stock Value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stockvalue')
    },
    {
        path: '/stock/outof_stock',
        name: 'Out of Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/outof_stock')
    },
    {
        path: '/stock/runningout_ofstock',
        name: 'Running out of stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/runningout_ofstock')
    },
    {
        path: '/stock/in_stock',
        name: 'In Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/in_stock')
    },
    {
        path: '/purchase/new',
        name: 'New Purchase',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/new_purchase')
    },
    {
        path: '/stock/spoilt',
        name: 'Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/spoilt_stock')
    },
    {
        path: '/stock/pendingspoilt',
        name: 'Pending SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/pending_spoiltstock')
    },
    {
        path: '/stock/rejectedspoilt',
        name: 'Rejected SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/rejected_spoiltstock')
    },
    {
        path: '/stock/batches',
        name: 'Batches',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/batches')
    },
    {
        path: '/stock/shortExpiries',
        name: 'Short Expiries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/short_expiries')
    },
    {
        path: '/stock/expired',
        name: 'ExpiredStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/expired')
    },
    {
        path: '/stock/reconcile',
        name: 'Reconcile Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile')
    },
    {
        path: '/stock/reconcileall',
        name: 'Reconcile all Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcileall')
    },
    {
        path: '/reconciliation/report',
        name: 'Reconciliation Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconciliation_report')
    },
    {
        path: '/reconciliation/details/:id',
        name: 'Reconciliation Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile_details')
    },
    {
        path: '/shop/purchases',
        name: 'Shop Purchase Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/shop_purchase_report')
    },

    {
        path: '/advanced_reports/sellingprice_changes',
        name: 'Selling Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sellingprice_changes')
    },

    {
        path: '/advanced_reports/shopprice_changes',
        name: 'Shop Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shopprice_changes')
    },

    {
        path: '/purchases/creditors',
        name: 'Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/creditors')
    },

    {
        path: '/purchases/imported_creditors',
        name: 'Imported Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/imported_creditors')
    },

    //  store
    {
        path: '/store/add',
        name: 'Add To Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/new_purchase')
    },
    {
        path: '/store/view',
        name: 'Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/stock')
    },
    {
        path: '/store/reconcile',
        name: 'Reconcile Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/reconcile')
    },
    {
        path: '/store/allstock',
        name: 'All Store Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/allstock')
    },
    {
        path: '/store/purchases',
        name: 'Store Purchases',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/store_purchases')
    },

    {
        path: '/advanced_reports/storeprice_changes',
        name: 'Store Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/storeprice_changes')
    },
    //  end store
    {
        path: '/cashin',
        name: 'CashIn',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/cashin')
    },
    {
        path: '/cashout',
        name: 'CashOut',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/cashout')
    },
    {
        path: '/supplierbalance_details/:id',
        name: 'SupplierBalance_details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalance_details')
    },
    {
        path: '/supplier_balances',
        name: 'SupplierBalances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalances')
    },
    {
        path: '/users/groups',
        name: 'Buy/sell',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/roles')
    },
    {
        path: '/users',
        name: 'Users',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/users')
    },
    {
        path: '/sales/order',
        name: 'NewOrder',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/sales')
    },
    {
        path: '/sales/confirm_order',
        name: 'Confirm Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/confirm_order')
    },
    {
        path: '/sales/readyorders',
        name: 'Ready Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/readyorders')
    },
    {
        path: '/sales',
        name: 'View Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/sales_report')
    },
    {
        path: '/sales/discounts',
        name: 'View Sale Discounts',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/discounts_allowed')
    },
    {
        path: '/payments',
        name: 'View Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/payments')
    },
    {
        path: '/sales/debtors',
        name: 'Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/debtors')
    },
    {
        path: '/sales/imported_debtors',
        name: 'Imported Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/imported_debtors')
    },
    {
        path: '/sales/held',
        name: 'Held Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/held_sales')
    },

    {
        path: '/advanced_reports/payments',
        name: 'Customer Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/payments_report')
    },

    {
        path: '/advanced_reports/credit_payments',
        name: 'Credit Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/credit_payments')
    },

    {
        path: '/hold/print/:id',
        name: 'Invoice',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/invoice')
    },
    {
        path: '/messages',
        name: 'Message Center',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/message_center')
    },
    {
        path: '/messages/buysms',
        name: 'MessageBuy',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/buysms')
    },
    {
        path: '/lpo',
        name: 'Purchase Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo')
    },
    {
        path: '/lpo/new',
        name: 'New LPO',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/new_lpo')
    },
    {
        path: '/lpo/details/:id',
        name: 'LPO Details',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/lpo_details')
    },
    {
        path: '/lpo/print/:id',
        name: 'Print LPO',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo_print')
    },
    {
        path: '/invoices/new',
        name: 'New Invoice',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/invoices/new_invoice')
    },
    {
        path: '/invoices/view',
        name: 'New Invoice',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/invoices/invoices')
    },
    {
        path: '/invoice/details/:id',
        name: 'Invoice Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/invoices/invoice_details')
    },
    {
        path: '/stock/transfer',
        name: 'Transfer Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfer_stock')
    },
    {
        path: '/stock/transfer/direct',
        name: 'Direct Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/direct_stock_transfer')
    },
    {
        path: '/stock/transfers',
        name: 'Stock Transfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfers')
    },
    {
        path: '/stock/movement/:id',
        name: 'Stock Movement',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/movements')
    },
    {
        path: '/audits',
        name: 'Audit Trails',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/audits')
    },
    {
        path: '/ui/images',
        name: 'Images',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/images')
    },
    {
        path: '/ui/modals',
        name: 'Modals',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/modals')
    },
    {
        path: '/ui/drawer',
        name: 'Drawer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/drawer')
    },
    {
        path: '/ui/rangeslider',
        name: 'Rangeslider',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/rangeslider')
    },
    {
        path: '/ui/progressbars',
        name: 'Progressbars',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/progressbars')
    },
    {
        path: '/ui/sweet-alert',
        name: 'Sweet-alert',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/sweet-alert')
    },
    {
        path: '/ui/tabs-accordions',
        name: 'Tabs-accordions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/tabs-accordions')
    },
    {
        path: '/ui/typography',
        name: 'Typography',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/typography')
    },
    {
        path: '/ui/video',
        name: 'Video',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/video')
    },
    {
        path: '/ui/general',
        name: 'General',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/general')
    },
    {
        path: '/ui/colors',
        name: 'Colors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/colors')
    },
    {
        path: '/payment/options',
        name: 'PaymentOptions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/payment_options')
    },
    {
        path: '/payment/transfers',
        name: 'MoneyTransfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/money_transfers')
    },
    {
        path: '/paymentOptions/statement/:id',
        name: 'ModeStatement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/mode_statement')
    },
    {
        path: '/customers',
        name: 'Customers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customers')
    },
    {
        path: '/customer/deposits',
        name: 'CustomerDeposit',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_deposit')
    },
    {
        path: '/customer/deposit_refund',
        name: 'CustomerDeposit Refund',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customerdeposit_refund')
    },
    {
        path: '/customer/balances',
        name: 'Customer Balances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_balance')
    },
    {
        path: '/customer/balance_details/:id',
        name: 'Customer Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_details')
    },
    {
        path: '/customer/print_balance_details/:id',
        name: 'Print Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_detailsprint')
    },
    {
        path: '/customer/customer_profile/:id',
        name: 'Customer History',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_profile')
    },
    {
        path: '/expenses/categories',
        name: 'ExpenseCategories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/categories')
    },
    {
        path: '/expenses/view',
        name: 'Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expenses')
    },
    {
        path: '/expenses/report',
        name: 'Expense Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/report')
    },
    {
        path: '/projects/create',
        name: 'Create New',
        meta: { authRequired: true },
        component: () =>
            import ('./views/projects/create')
    },
    {
        path: '/contacts/grid',
        name: 'User Grid',
        meta: { authRequired: true },
        component: () =>
            import ('./views/contacts/contacts-grid')
    },
    {
        path: '/contacts/list',
        name: 'User List',
        meta: { authRequired: true },
        component: () =>
            import ('./views/contacts/contacts-list')
    },
    {
        path: '/contacts/profile',
        name: 'Profile',
        meta: { authRequired: true },
        component: () =>
            import ('./views/contacts/contacts-profile')
    },
    {
        path: '/charts/apex',
        name: 'Apex chart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/charts/apex')
    },
    {
        path: '/charts/chartjs',
        name: 'Chartjs chart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/charts/chartjs/index')
    },
    {
        path: '/charts/chartist',
        name: 'Chartist chart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/charts/chartist')
    },
    {
        path: '/charts/echart',
        name: 'Echart chart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/charts/echart/index')
    },
    {
        path: '/icons/boxicons',
        name: 'Boxicons Icon',
        meta: { authRequired: true },
        component: () =>
            import ('./views/icons/boxicons')
    },
    {
        path: '/icons/materialdesign',
        name: 'Materialdesign Icon',
        meta: { authRequired: true },
        component: () =>
            import ('./views/icons/materialdesign')
    },
    {
        path: '/icons/dripicons',
        name: 'Dripicons Icon',
        meta: { authRequired: true },
        component: () =>
            import ('./views/icons/dripicons')
    },
    {
        path: '/icons/fontawesome',
        name: 'Fontawesome Icon',
        meta: { authRequired: true },
        component: () =>
            import ('./views/icons/fontawesome')
    },
    {
        path: '/maps/google',
        name: 'Google Maps',
        meta: { authRequired: true },
        component: () =>
            import ('./views/maps/google')
    },
    {
        path: '/maps/leaflet',
        name: 'Leaflet Maps',
        meta: { authRequired: true },
        component: () =>
            import ('./views/maps/leaflet/index')
    },
    {
        path: '/tables/basic',
        name: 'Basic Tables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/tables/basictable')
    },
    {
        path: '/tables/advanced',
        name: 'Advanced Tables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/tables/advancedtable')
    },
    {
        path: '/form/advanced',
        name: 'Form Advanced',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/advanced')
    },
    {
        path: '/form/elements',
        name: 'Form Elements',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/elements')
    },
    {
        path: '/form/layouts',
        name: 'Form Layouts',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/layouts')
    },
    {
        path: '/form/editor',
        name: 'Form Editors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/editors')
    },
    {
        path: '/form/uploads',
        name: 'File Uploads',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/uploads')
    },
    {
        path: '/form/validation',
        name: 'Form Validation',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/validation')
    },
    {
        path: '/form/wizard',
        name: 'Form Wizard',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/wizard')
    },
    {
        path: '/form/repeater',
        name: 'Form Repeater',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/repeater')
    },
    {
        path: '/form/mask',
        name: 'Form Mask',
        meta: { authRequired: true },
        component: () =>
            import ('./views/forms/mask')
    },
    {
        path: '/pages/starter',
        name: 'Starter',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/starter')
    },
    {
        path: '/pages/maintenance',
        name: 'Maintenance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/maintenance')
    },
    {
        path: '/pages/coming-soon',
        name: 'coming-soon',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/coming-soon')
    },
    {
        path: '/pages/timeline',
        name: 'Timeline',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/timeline')
    },
    {
        path: '/pages/faqs',
        name: 'FAQs',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/faqs')
    },
    {
        path: '/pages/pricing',
        name: 'Pricing',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/pricing')
    },
    {
        path: '/pages/404',
        name: 'Error-404',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/404')
    },
    {
        path: '/pages/500',
        name: 'Error-500',
        meta: { authRequired: true },
        component: () =>
            import ('./views/utility/500')
    },
    {
        path: '/email/inbox',
        name: 'Inbox',
        meta: { authRequired: true },
        component: () =>
            import ('./views/email/inbox')
    },
    {
        path: '/email/reademail/:id',
        name: 'Read Email',
        meta: { authRequired: true },
        component: () =>
            import ('./views/email/reademail')
    },
    {
        path: '/email/templates/basic',
        name: 'Email template basic',
        meta: { authRequired: true },
        component: () =>
            import ('./views/email/templates/basic')
    },
    {
        path: '/email/templates/billing',
        name: 'Email template billing',
        meta: { authRequired: true },
        component: () =>
            import ('./views/email/templates/billing')
    },
    {
        path: '/email/templates/alert',
        name: 'Email template alert',
        meta: { authRequired: true },
        component: () =>
            import ('./views/email/templates/alert')
    },
    {
        path: '/settings/general',
        name: 'General Settings',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/general_settings')
    },
    {
        path: '/settings/receipt',
        name: 'Receipt Settings',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/receipt_settings')
    },
    {
        path: '/tasks/create',
        name: 'Create Task',
        meta: { authRequired: true },
        component: () =>
            import ('./views/tasks/task-create')
    },
    {
        path: '/auth/login-1',
        name: 'Login sample',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/login-sample')
    },
    {
        path: '/auth/login-2',
        name: 'Login-2-sample',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/login-2')
    },
    {
        path: '/auth/register-1',
        name: 'Register sample',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/register-sample')
    },
    {
        path: '/auth/register-2',
        name: 'Register-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/register-2')
    },
    {
        path: '/auth/recoverpwd',
        name: 'Recover pwd',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/recoverpw-sample')
    },
    {
        path: '/auth/recoverpwd-2',
        name: 'Recover pwd-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/recoverpwd-2')
    },
    {
        path: '/auth/lock-screen',
        name: 'Lock screen',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/lockscreen')
    },
    {
        path: '/auth/lock-screen-2',
        name: 'Lock screen-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/lockscreen-2')
    },
    {
        path: '/auth/confirm-mail',
        name: 'confirm-mail',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/confirm-mail')
    },
    {
        path: '/auth/confirm-mail-2',
        name: 'confirm-mail-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/confirm-mail-2')
    },
    {
        path: '/auth/email-verification',
        name: 'email-verification',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/email-verification')
    },
    {
        path: '/auth/email-verification-2',
        name: 'email-verification-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/email-verification-2')
    },
    {
        path: '/auth/two-step-verification',
        name: 'two-step-verification',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/two-step-verification')
    },
    {
        path: '/auth/two-step-verification-2',
        name: 'two-step-verification-2',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sample-pages/two-step-verification-2')
    },

    // Advanced Reports
    {
        path: '/advanced_reports/debtors_report',
        name: 'Debtors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/debtors_report')
    },
    {
        path: '/advanced_reports/creditors_report',
        name: 'Creditors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/creditors_report')
    },
    {
        path: '/advanced_reports/expenses_report',
        name: 'Expenses Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/expenses_report')
    },
    {
        path: '/advanced_reports/held_sales_report',
        name: 'Held Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/held_sales_report')
    },
    {
        path: '/advanced_reports/sales_report',
        name: 'Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sales_report')
    },
    {
        path: '/advanced_reports/shop_purchases_report',
        name: 'Shop Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shop_purchases_report')
    },
    {
        path: '/advanced_reports/store_purchases_report',
        name: 'Store Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/store_purchases_report')
    },
    {
        path: '/advanced_reports/stocktransfers_report',
        name: 'Stock Transfers Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/stocktransfers_report')
    },
    {
        path: '/advanced_reports/internalstock_transfer',
        name: 'InternalStock Transfers Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/internalstock_transfer')
    },
    {
        path: '/stock/intransfer',
        name: 'Internal Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/intransfer_stock')
    },
    {
        path: '/advanced_reports/purchase_payments',
        name: 'Purchase payments Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchase_payments')
    },
    {
        path: '/advanced_reports/product_demand',
        name: 'Product demand Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/product_demand')
    },
    {
        path: '/advanced_reports/income_statement',
        name: 'Income statement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/income_statement')
    },
    {
        path: '/advanced_reports/transactions_report',
        name: 'Transactions Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/transactions_report')
    },
    {
        path: '/advanced_reports/profitanalysis_report',
        name: 'Profit Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/profitanalysis_report')
    },
    {
        path: '/advanced_reports/salesanalysis_report',
        name: 'Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salesanalysis_report')
    },
    {
        path: '/advanced_reports/users_sales',
        name: 'User Sales Summary',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/user_sales_summary')
    },
    {
        path: '/advanced_reports/consumption',
        name: 'Product Consumption',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/product_consumption_report')
    },
    {
        path: '/advanced_reports/purchasereturns_report',
        name: 'Purchase Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchasereturns_report')
    },
    {
        path: '/advanced_reports/salereturns_report',
        name: 'Sale Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salereturns_report')
    },
    {
        path: '/advanced_reports/advancedsales_report',
        name: 'Advanced Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/advancedsales_report')
    },
    {
        path: '/advanced_reports/monthlysales_report',
        name: 'Monthly Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_report')
    },
    {
        path: '/advanced_reports/monthlysales_details/:date/:period',
        name: 'Monthly Sales Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_details')
    },
    {
        path: '/advanced_reports/monthlyprofits_report',
        name: 'Monthly Profits Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_report')
    },
    {
        path: '/advanced_reports/monthlyprofits_details/:date/:period',
        name: 'Monthly Profits Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_details')
    },
    {
        path: '/users/permissions',
        name: 'Permissions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/permissions')
    },
    {
        path: '/users/access_time',
        name: 'Accesstime',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/access_time')
    },
    // Consumables
    {
        path: '/consumables/currentstock',
        name: 'Consumables Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/currentstock')
    },
    {
        path: '/consumables/add_item',
        name: 'Add Consumable Items',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/add_item')
    },
    {
        path: '/consumables/stocking',
        name: 'Stock Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/stocking')
    },
    {
        path: '/consumables/usage',
        name: 'Use Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/usage')
    },
    {
        path: '/consumables/stocking_report',
        name: 'Consumable Stocking Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/stocking_report')
    },
    {
        path: '/consumables/usage_report',
        name: 'Consumables Usage Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/usage_report')
    },
    {
        path: '/consumables/creditors',
        name: 'Consumables Credtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/creditors')
    },


    // Visualisation centre
    {
        path: '/user_performance',
        name: 'User Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/userperformance')
    },

    {
        path: '/product_performance',
        name: 'Product Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/productperformance')
    },

    {
        path: '/tabular_userperformance',
        name: 'Tabular User Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/tabular_userperformance')
    },

    {
        path: '/tabular_productperformance',
        name: 'Tabular Product Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/tabular_productperformance')
    },

    {
        path: '/staff',
        name: 'Staff',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staff')
    },

]